module.exports = __webpack_public_path__ + "img/just-listed-header.94628957.png";